<h1 class="text-dark-grey text-font-16 font-DIN-Bold font-bold">
	{{ 'STORE.ADD_PRODUCT.VARIANT_INFO' | translate }}
</h1>
<div class="py-16px">
	<div class="p-24px rounded-12px bg-off-white sectionShadow mb-24px w-[776px]">
		<app-products-slider
			[smallSize]="true"
			(updateData)="getController('gallaryImageUrls')?.setValue($event)"
			[ProductData]="getController('gallaryImageUrls')?.value"
			(mainImage)="
				this.productVariantForm.get('mainImageUrl')?.patchValue($event)
			"
			[mainImageDisplay]="getController('mainImageUrl')?.value"
			(deleteImgUrl)="deleteImg($event)"
		></app-products-slider>
		<form [formGroup]="productVariantForm">
			<!-- VARIANT INFO  -->

			<div
				class="flex justify-between mt-16px bg-main-color-black p-12px rounded-12px"
			>
				<p class="text-gradient m-0">
					{{ 'STORE.ADD_PRODUCT.VARIANT_STATUS' | translate }}
				</p>
				<div>
					<!-- TOGGLE  -->
					<div>
						<p
							*ngIf="getController('isActive')?.value"
							class="inline-block text-font-16 text-[#00BA88] mb-0 ltr:mr-[16px] rtl:ml-[16px]"
						>
							{{ 'OFFERS.OFFERS_LIST.ACTIVE' | translate }}
						</p>
						<p
							*ngIf="!getController('isActive')?.value"
							class="inline-block text-font-16 text-medium-gray mb-0 ltr:mr-[16px] rtl:ml-[16px]"
						>
							{{ 'OFFERS.OFFERS_LIST.INACTIVE' | translate }}
						</p>
						<mat-slide-toggle
							(change)="
								this.getController('isActive')?.setValue($event?.checked)
							"
							[checked]="getController('isActive')?.value"
							class="align-top"
							hideIcon
						>
						</mat-slide-toggle>
					</div>
					<!-- TOGGLE  -->
				</div>
			</div>
			<!-- OPTIONS -->
			<div
				class="w-full mt-16px {{
					this.variantsData.length > 0 ? 'pointer-events-none' : ''
				}}"
			>
				<mat-form-field
					[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
					class="w-full mb-[16px] text-dark-grey {{
						this.variantsData.length > 0 ? 'custom-form' : ''
					}}"
					appearance="outline"
				>
					<mat-label class="text-dark-grey">
						{{ 'STORE.ADD_PRODUCT.VARIANT_TYPE' | translate }}</mat-label
					>

					<mat-select
						class="w-full"
						#optionSelect
						formControlName="variantTypeId"
						required
						(valueChange)="this.getController('variantTypeSettings').reset()"
					>
						<mat-select-trigger class="w-full" class="text-main-color-black">
							{{
								translate.currentLang == 'en'
									? getController('variantTypeId')?.value?.nameEn
									: getController('variantTypeId')?.value?.nameAr
							}}
						</mat-select-trigger>
						<mat-option
							class="my-2"
							*ngFor="let type of variantTypes"
							[value]="type"
						>
							<p class="inline-block">
								{{
									translate.currentLang == 'en' ? type?.nameEn : type?.nameAr
								}}
							</p>
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<!-- VARIANT COLOR SIZE  -->
			<ng-container *ngIf="getController('variantTypeId')?.value?.id == 1">
				<div class="flex justify-center gap-[16px]">
					<mat-form-field class="w-full" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.HEX' | translate }}
						</mat-label>
						<input
							(change)="inputChange($event)"
							formControlName="variantTypeSettings"
							required="true"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="text"
							matInput
							maxlength="150"
							placeholder="{{ 'STORE.ADD_PRODUCT.COLOR' | translate }}"
						/>

						<mat-error>
							<validation-message
								[controller]="getController('variantTypeSettings')"
								controller_name="STORE.ADD_PRODUCT.COLOR"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<div
						(change)="
							this.getController('variantTypeSettings').setValue($event)
						"
						format="hex"
						ngx-colors-trigger
						formControlName="variantTypeSettings"
					>
						<div
							class="w-[48px] h-[48px] rounded-full flex justify-center items-center mt-1"
							[ngClass]="{
								'bg-salon': !getController('variantTypeSettings').value
							}"
							[ngStyle]="{
								'background-color':
									getController('variantTypeSettings').value || ''
							}"
						>
							<img src="./assets/images/color_picker_white.svg" alt="" />
						</div>
						<!-- <ngx-colors
							ngx-colors-trigger
							format="hex"
							formControlName="variantTypeSettings"
							style="display: inline-block; margin: 5px"
						></ngx-colors> -->
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="getController('variantTypeId')?.value?.id == 2">
				<mat-form-field class="w-full" appearance="outline">
					<mat-label class="text-dark-grey"
						>{{ 'STORE.ADD_PRODUCT.VARIANT_SIZE' | translate }}
					</mat-label>
					<input
						formControlName="variantTypeSettings"
						required="true"
						class="text-font-16 text-[#4E4B66] w-[96%]"
						type="text"
						matInput
						maxlength="150"
						placeholder="{{ 'STORE.ADD_PRODUCT.VARIANT_SIZE' | translate }}"
					/>

					<mat-error>
						<validation-message
							[controller]="getController('variantTypeSettings')"
							controller_name="STORE.ADD_PRODUCT.VARIANT_SIZE"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
			</ng-container>
			<!-- VARIANT COLOR SIZE  -->
			<!-- OPTIONS -->
			<!-- VARIANCE NAME   -->
			<div class="mt-16px">
				<div
					formGroupName="variantName"
					class="flex justify-between items-start"
				>
					<mat-form-field class="w-[49%]" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.VARIANT_NAME_EN' | translate }}
						</mat-label>
						<input
							formControlName="en"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="text"
							matInput
							maxlength="150"
							placeholder="{{
								'STORE.ADD_PRODUCT.VARIANT_NAME_EN' | translate
							}}"
						/>

						<mat-error>
							<validation-message
								[controller]="getNameFormGroupController('en')"
								controller_name="STORE.ADD_PRODUCT.VARIANT_NAME_EN"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<mat-form-field class="w-[49%]" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.VARIANT_NAME_AR' | translate }}
						</mat-label>
						<input
							formControlName="ar"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="text"
							matInput
							maxlength="150"
							placeholder="{{
								'STORE.ADD_PRODUCT.VARIANT_NAME_AR' | translate
							}}"
						/>

						<mat-error>
							<validation-message
								[controller]="getNameFormGroupController('ar')"
								controller_name="STORE.ADD_PRODUCT.VARIANT_NAME_AR"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<!-- VARIANCE NAME   -->
			<!-- PRICE & SKU  -->
			<div class="mt-24px flex justify-between">
				<div class="w-[49%]">
					<h1
						class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
					>
						{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}
					</h1>

					<mat-form-field class="w-full" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}
						</mat-label>
						<input
							(wheel)="$event.preventDefault()"
							formControlName="price"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="number"
							matInput
							maxlength="150"
							placeholder="{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}"
						/>
						<span class="text-dark-grey mx-2" matSuffix>
							{{
								this.countryId == 103
									? ('CURRENCY.SAR' | translate)
									: ('CURRENCY.EGP' | translate)
							}}
						</span>
						<mat-error>
							<validation-message
								[controller]="getController('price')"
								controller_name="STORE.ADD_PRODUCT.PRICE"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="w-[49%]">
					<h1
						class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
					>
						{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
					</h1>

					<mat-form-field class="w-full" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
						</mat-label>
						<input
							(keyup)="checkUnique($event)"
							formControlName="skuNumber"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="text"
							matInput
							maxlength="150"
							placeholder="{{ 'STORE.ADD_PRODUCT.SKU' | translate }}"
						/>

						<mat-error>
							<validation-message
								[controller]="getController('skuNumber')"
								controller_name="STORE.ADD_PRODUCT.SKU"
							>
							</validation-message>
						</mat-error>
						<mat-error
							*ngIf="productVariantForm.get('skuNumber')?.errors?.unique"
						>
							<span class="text-red-error text-font-12">{{
								'VALIDATION.SKU_UNIQUE' | translate
							}}</span>
						</mat-error>
					</mat-form-field>
				</div>
				<!-- PRICE  -->
			</div>
			<!-- PRICE & SKU  -->
			<!-- DISCOUNT & INVENTORY  -->
			<div class="mt-24px flex justify-between">
				<div class="w-[49%]">
					<h1
						class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-6px"
					>
						{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}
					</h1>
					<div class="mb-12px">
						<mat-radio-group
							(change)="getController('discountAmount')?.setValue('')"
							formControlName="isDiscountFixed"
						>
							<mat-radio-button
								[checked]="getController('isDiscountFixed')?.value == true"
								[value]="true"
								>{{
									'STORE.ADD_PRODUCT.FIXED_PRICE' | translate
								}}</mat-radio-button
							>
							<mat-radio-button [value]="false">{{
								'STORE.ADD_PRODUCT.PERCENTAGE' | translate
							}}</mat-radio-button>
						</mat-radio-group>
					</div>
					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}
						</mat-label>
						<input
							(wheel)="$event.preventDefault()"
							formControlName="discountAmount"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="number"
							matInput
							maxlength="150"
							placeholder="{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}"
						/>
						<span
							*ngIf="getController('isDiscountFixed')?.value == true"
							class="text-dark-grey mx-2"
							matSuffix
						>
							{{
								this.countryId == 103
									? ('CURRENCY.SAR' | translate)
									: ('CURRENCY.EGP' | translate)
							}}
						</span>
						<spans
							*ngIf="getController('isDiscountFixed')?.value == false"
							class="text-dark-grey mx-2"
							matSuffix
						>
							{{ '%' }}
						</spans>
						<mat-error>
							<validation-message
								[controller]="getController('discount')"
								controller_name="STORE.ADD_PRODUCT.DISCOUNT"
							>
							</validation-message>
						</mat-error>
						<mat-error
							*ngIf="
								this.productVariantForm
									.get('discountAmount')
									?.hasError('discountMoreThanPrice')
							"
						>
							{{ 'VALIDATION.DISCOUNT_LESS_THAN_PRICE' | translate }}</mat-error
						>
						<mat-error
							*ngIf="
								this.productVariantForm
									.get('discountAmount')
									?.hasError('percentageMax')
							"
						>
							{{ 'VALIDATION.DISCOUNT_PERCENTAGE_MAX' | translate }}</mat-error
						>
					</mat-form-field>
				</div>
				<div class="w-[49%]">
					<h1
						class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
					>
						{{ 'STORE.ADD_PRODUCT.INVENTORY' | translate }}
					</h1>
					<!-- LOW QUANTITY  -->
					<div class="flex items-center mb-6px">
						<mat-checkbox
							[checked]="getController('hasLowQuantity')?.value"
							formControlName="hasLowQuantity"
							class="rtl:ml-8px ltr:mr-8px"
						></mat-checkbox>
						<p class="m-0">
							{{ 'STORE.ADD_PRODUCT.LOW_QUANTITY' | translate }}
						</p>
					</div>
					<!-- LOW QUANTITY  -->
					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'STORE.ADD_PRODUCT.STOCK_AVAILABILITY' | translate }}
						</mat-label>
						<input
							required="true"
							(wheel)="$event.preventDefault()"
							formControlName="stockCount"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="number"
							matInput
							placeholder="{{ 'STORE.ADD_PRODUCT.STOCK' | translate }}"
						/>
						<span class="text-dark-grey mx-2" matSuffix>
							{{ 'STORE.ADD_PRODUCT.STOCK' | translate }}
						</span>
						<mat-error>
							<validation-message
								[controller]="getController('stockCount')"
								controller_name="STORE.ADD_PRODUCT.STOCK"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<!-- DISCOUNT & INVENTORY  -->
			<!-- ADD & CANCEL -->
			<div class="mt-24px flex justify-between">
				<button
					(click)="resetVariantForm()"
					class="text-link py-[15px] px-[10px]"
				>
					{{ 'ACTIONS.RESET' | translate }}
				</button>
				<div class="customBtn">
					<button
						mat-button
						[disabled]="
							productVariantForm.invalid ||
							this.getController('skuNumber').value.length == 0
						"
						(click)="addNewVariant()"
						class="text-off-white bg-gradient py-[15px] px-24px rounded-[6px] customBtn"
					>
						{{ 'ACTIONS.ADD' | translate }}
					</button>
				</div>
			</div>
			<!-- ADD & CANCEL -->
		</form>
	</div>
</div>

<!-- VARIANT INFO  -->

<!-- VARIANTS TABLE  -->

<ng-container
	*ngIf="
		(variantsData.length > 0 && hasVariants) ||
		(variantsData.length > 0 && (addMode || editMode))
	"
>
	<h1 class="text-dark-grey text-font-16 font-DIN-Bold font-bold">
		{{ 'STORE.ADD_PRODUCT.VARIANTS' | translate }}
	</h1>
	<div class="custom-table overflow-x-auto">
		<table class="mat-elevation-z8 bg-transparent w-full relative">
			<thead class="bg-light">
				<tr class="border-b-[1px] border-secondry-color-Gray">
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'STORE.ADD_PRODUCT.VARIANT_NAME' | translate }}
					</td>

					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
					>
						{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
					>
						<!-- {{ 'STORE.ADD_PRODUCT.STOCK' | translate }} -->
						{{ 'STORE.ADD_PRODUCT.PRICE_DISCOUNT' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
					>
						{{ 'STORE.ADD_PRODUCT.QUANTITY' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
					>
						{{ 'STORE.ADD_PRODUCT.STATUS' | translate }}
					</td>
					<td></td>
				</tr>
			</thead>
			<tbody class="bg-grey-background">
				<ng-container *ngFor="let variant of variantsData; let i = index">
					<tr>
						<td
							class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							<span
								class="flex items-center justify-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative gap-[6px]"
							>
								<img
									[src]="attachmentUrl + variant?.mainImageUrl"
									alt=""
									class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
								/>
								<span>
									<span
										*ngIf="translate.currentLang == 'en'"
										class="block whitespace-normal text-dark-grey"
									>
										{{
											variant?.variantName?.en
												? variant.variantName.en.length > 13
													? (variant?.variantName?.en | slice : 0 : 13)
													: variant?.variantName?.en
												: null
										}}

										{{
											variant?.variantName?.en
												? variant.variantName.en.length > 13
													? '...'
													: null
												: null
										}}
									</span>
									<span
										*ngIf="translate.currentLang == 'ar'"
										class="block whitespace-normal text-dark-grey"
									>
										{{
											variant?.variantName?.ar
												? variant.variantName.ar.length > 13
													? (variant?.variantName?.ar | slice : 0 : 13)
													: variant?.variantName?.ar
												: null
										}}

										{{
											variant?.variantName?.ar
												? variant.variantName.ar.length > 13
													? '...'
													: null
												: null
										}}
									</span>
								</span>
								<span
									*ngIf="variant?.variantType?.id == 1"
									class="h-[24px] w-[24px] rounded-full"
									[style.backgroundColor]="variant?.variantTypeSettings || ''"
								>
								</span>
								<span
									*ngIf="variant?.variantType?.id == 2"
									class="text-font-14 text-dark-grey"
								>
									<p class="m-0">{{ variant?.variantTypeSettings }}</p>
								</span>
							</span>
						</td>
						<td
							class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							{{ variant?.skuNumber }}
						</td>
						<td
							class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
						>
							<h1
								class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0"
							>
								{{
									countryId == 103
										? ('CURRENCY.SAR' | translate)
										: ('CURRENCY.EGP' | translate)
								}}
								{{ variant?.price }}
							</h1>
							<p
								*ngIf="variant?.discountAmount"
								class="text-medium-gray text-font-14"
							>
								<span
									*ngIf="variant?.isDiscountFixed && variant?.discountAmount"
									>{{ variant?.discountAmount }}
									{{
										countryId == 103
											? ('CURRENCY.SAR' | translate)
											: ('CURRENCY.EGP' | translate)
									}}</span
								>
								<span
									*ngIf="!variant?.isDiscountFixed && variant?.discountAmount"
									>{{ variant?.discountAmount }} {{ '% '
									}}{{ 'STORE.ADD_PRODUCT.OFF' | translate }}</span
								>
							</p>
						</td>
						<td
							class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							<div class="inline-block">
								<p
									*ngIf="variant?.stockCount ? variant.stockCount > 0 : null"
									class="text-font-16 text-dark-grey m-0"
								>
									{{ variant?.stockCount }}
								</p>
								<p
									*ngIf="variant?.stockCount == 0"
									class="text-font-16 leading-[22px] text-[#B3261E] m-0"
								>
									{{ 'STATUS.OUTOFSTOCK' | translate }}
								</p>
							</div>
							<img
								*ngIf="variant?.hasLowQuantity"
								class="inline-block"
								src="./assets/images/arrow_down_red.svg"
								alt=""
							/>
						</td>
						<td
							class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							<mat-slide-toggle
								[checked]="variant?.isActive"
								(change)="
									variantsData[i].isActive = $event.checked;
									editMode && variantsData[i].id
										? changeProductVariantStatus(
												variantsData[i].id,
												$event.checked
										  )
										: null;
									productsVariantsEmitter.emit(variantsData)
								"
							></mat-slide-toggle>
							<p
								*ngIf="variantsData[i].isActive"
								class="inline-block text-font-16 text-[#00BA88] mb-0 ltr:mr-[16px] rtl:ml-[16px]"
							>
								{{ 'OFFERS.OFFERS_LIST.ACTIVE' | translate }}
							</p>
							<p
								*ngIf="!variantsData[i].isActive"
								class="inline-block text-font-16 text-medium-gray mb-0 ltr:mr-[16px] rtl:ml-[16px]"
							>
								{{ 'OFFERS.OFFERS_LIST.INACTIVE' | translate }}
							</p>
						</td>

						<td
							class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							<span
								(click)="editVariantDialog(variantsData[i], i)"
								*ngIf="!viewMode"
								class="inline-block max-mobile:w-[20px] w-[16px] text-end cursor-pointer"
							>
								<img [src]="'assets/images/edit.svg'" alt="" />
							</span>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</ng-container>
<!-- VARIANTS TABLE  -->
